import * as React from "react";
import { useState } from "react";
import * as ReactModal from "react-modal";

interface ModalProps {
    name: string;
    // open: boolean;
    shouldCloseOnOverlayClick?: boolean;
    show: boolean;

    onAfterOpen?: () => void;
    onRequestClose?: () => void;
    children?: React.ReactNode;
}

export default function Modal({
    name,
    show,
    shouldCloseOnOverlayClick,
    onAfterOpen,
    onRequestClose,
    children,
}: ModalProps) {
    const closeOnOverlayClick: boolean =
        shouldCloseOnOverlayClick !== undefined
            ? shouldCloseOnOverlayClick
            : true;

    return show ? (
        <ReactModal
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={closeOnOverlayClick}
            isOpen={show}
            onAfterOpen={onAfterOpen}
            contentLabel="Modal"
            styles={{}}
            defaultStyles={{}}
            className={{
                base: `ReactModal__Content ReactModal__Content--${name}`,
                afterOpen: "ReactModal__Content--after-open",
                beforeClose: "ReactModal__Content--before-close",
            }}
        >
            {children}
        </ReactModal>
    ) : null;
}
